import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';

/**
 * LangToggle — a big, one-tap AR/EN switch for the staff (shop-floor) header.
 *
 * Calls i18n.changeLanguage (persisted by the existing i18next LanguageDetector,
 * and the document `dir`/`lang` are kept in sync by Layout's effect). The label
 * shows the language you'll switch TO: in English it reads "العربية", in Arabic
 * it reads "EN". ≥ 56px touch target, icon + short word, RTL-safe (logical
 * spacing). Hidden visually from non-staff surfaces by where it's mounted.
 *
 * Props:
 *   className — extra wrapper classes
 */
const LangToggle = ({ className = '' }) => {
  const { t, i18n } = useTranslation();

  const next = i18n.language === 'ar' ? 'en' : 'ar';
  const toggle = () => {
    i18n.changeLanguage(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="lang-toggle"
      aria-label={t('staff.lang.toggleAria')}
      className={`min-h-[56px] min-w-[56px] px-4 inline-flex items-center justify-center gap-2 rounded-2xl bg-surface-2 text-content font-bold text-base border border-edge hover:bg-surface-3 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      <FiGlobe size={22} className="shrink-0" />
      <span>{t('staff.lang.toggle')}</span>
    </button>
  );
};

export default LangToggle;
